module.exports = __webpack_public_path__ + "img/702.d7c7fd01.jpg";